<template>
    <v-card outlined>
        <v-card-text>
            <v-row wrap ro align="center">
                <v-col cols="12">
                    <!-- Selector de Tipo de Equipamiento (Kit) -->
                    <v-row dense align="center" class="mb-2">
                        <v-col cols="12" sm="6">
                        <v-autocomplete
                            v-model="tipoEquipamientoSeleccionado"
                            :items="plantillasDisponibles"
                            item-text="tipo"
                            item-value="id"
                            label="Tipo de Equipamiento"
                            placeholder="Seleccionar tipo..."
                            clearable
                            outlined
                            dense
                            :disabled="loadingPlantilla"
                        />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-btn
                                color="primary"
                                @click="agregarKitPlantilla"
                                :loading="loadingPlantilla"
                                :disabled="!tipoEquipamientoSeleccionado || loadingPlantilla"
                                block
                            >
                                <v-icon left>mdi-playlist-plus</v-icon>
                                AGREGAR KIT
                            </v-btn>
                        </v-col>
                    </v-row>

                    <form autocomplete="nope" @submit.prevent="postData">
                        <v-container grid-list-md fluid>
                            <v-row dense align="center">
                                <v-col cols="12" sm="8">
                                    <v-autocomplete dense v-model="servicio.id" v-validate="'required'" label="Producto"
                                        :items="searchResults"
                                        :loading="isSearching"
                                        :search-input.sync="productSearch"
                                        placeholder="Ej: laptop dell"
                                        data-vv-as="marca"
                                        :error-messages="errors.collect('servicio.id')" data-vv-name="servicio.id" required
                                        item-text="displayName" item-value="id"
                                        no-filter
                                        hide-no-data
                                        @input="onProductSelected"
                                    >
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="12" sm="2">
                                    <v-text-field v-validate="'required'" required dense v-model="servicio.quantity" label="Unidades" @keypress="isNumber" />
                                </v-col>
                                <v-col cols="12" sm="2" class="text-center"><v-btn block color="secondaryTheme" dark
                                        type="submit">agregar</v-btn>
                                </v-col>
                                <v-spacer></v-spacer>
                            </v-row>
                        </v-container>
                    </form>
                </v-col>
                <v-col cols="12" class="grey lighten-5">
                    <v-data-table multi-sort :headers="headers" :items="inventory" class="elevation-1" :items-per-page="20"
                        item-key="timestamp">
                        <template v-slot:[`item.action`]="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" color="green"
                                        @click="upItem(item)">mdi-swap-vertical</v-icon>
                                </template>
                                <span>SUBIR</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon color="primary" v-bind="attrs" v-on="on" small
                                        @click="deleteItem(item)">mdi-delete</v-icon>
                                </template>
                                <span>ELIMINAR</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script>
import { mapState } from 'vuex'
import { mixins } from '@/mixins/mixin.js'
import DefaultForm from '@/utils/defaultForm'
import { debounce } from 'lodash'
import request from '@/utils/request'
export default {
    filters: {},
    props: ['lista', 'service',],
    mixins: [mixins],
    $_veeValidate: {
        validator: 'new'
    },
    data() {
        return {
            isLoading: false,
            model: null,
            servicio: DefaultForm.formSelectServicio(),
            listaServicios: [],
            search: null,
            productSearch: '',
            searchResults: [],
            isSearching: false,
            selectedProduct: null,
            // Plantillas de equipamiento (kits)
            plantillasDisponibles: [],
            tipoEquipamientoSeleccionado: null,
            plantillaSeleccionada: null,
            loadingPlantilla: false,
            headers: [
                { text: 'Actions', value: 'action', sortable: false },
                { text: 'Descripción', value: 'name' },
                { text: 'Codigo', value: 'internal_id' },
                { text: 'Unidades', value: 'quantity' },
            ]
        }
    },

    watch: {
        productSearch: debounce(function(val) {
            // Si ya hay un producto seleccionado (tiene id), no buscar
            if (this.servicio && this.servicio.id) {
                return
            }
            if (!val || val.trim().length < 4) {
                this.searchResults = []
                return
            }
            
            this.performProductSearch(val)
        }, 500)
    },

    computed: {
        ...mapState('inventario', ['inventory']),
        ...mapState('users', ['user'])
    },
    async mounted() {
        await this.cargarPlantillas()
    },
    methods: {
        async performProductSearch(searchText) {
            this.isSearching = true
            try {
                const results = await this.$store.dispatch('productos/searchProductos', {
                    text: searchText,
                    idSede: this.user.idSede,
                    showInternals: true
                })
                
                // Format results for display
                this.searchResults = results.map(p => ({
                    ...p,
                    displayName: `${p.internal_id} - ${p.name || p.description}`
                }))
            } catch (error) {
                console.error('Product search error:', error)
                this.searchResults = []
            } finally {
                this.isSearching = false
            }
        },
        
        onProductSelected(productId) {
            if (!productId || this.searchResults.length === 0) return
            const selected = this.searchResults.find(p => p.id === productId)
            if (selected) {
                this.selectedProduct = selected
                this.servicio.id = productId
            }
        },

        async cargarPlantillas() {
            try {
                const { data } = await request({
                    url: '/ms/inventario/private/1.0/equipamiento/plantillas',
                    method: 'GET'
                })
                if (data.codigoRespuesta === '00') {
                    this.plantillasDisponibles = data.data.filter(p => p.activo)
                }
            } catch (error) {
                console.error('Error cargando plantillas:', error)
            }
        },

        async agregarKitPlantilla() {
            if (!this.tipoEquipamientoSeleccionado) return

            this.loadingPlantilla = true
            try {
                const { data } = await request({
                    url: `/ms/inventario/private/1.0/equipamiento/plantilla/${this.tipoEquipamientoSeleccionado}`,
                    method: 'GET'
                })

                if (data.codigoRespuesta === '00' && data.data) {
                    let items = data.data.items || []
                    if (typeof items === 'string') {
                        try {
                            let parsed = JSON.parse(items)
                            if (typeof parsed === 'string') parsed = JSON.parse(parsed)
                            items = Array.isArray(parsed) ? parsed : []
                        } catch (e) {
                            items = []
                        }
                    }
                    if (Array.isArray(items)) {
                        // Buscar IDs reales de productos por internal_id
                        const itemsWithId = await Promise.all(items
                            .filter(item => item != null)
                            .map(async (item) => {
                                const internalId = item.internal_id || item.codigo || ''
                                let productId = item.id || item.individual_item_id || null

                                // Si no tiene id real, buscarlo por internal_id
                                if (!productId && internalId) {
                                    try {
                                        const results = await this.$store.dispatch('productos/searchProductos', {
                                            text: internalId,
                                            idSede: this.user.idSede,
                                            showInternals: true
                                        })
                                        const found = results.find(p => p.internal_id === internalId)
                                        if (found) productId = found.id
                                    } catch (e) {
                                        console.warn(`No se pudo buscar producto ${internalId}:`, e.message)
                                    }
                                }

                                return {
                                    id: productId,
                                    name: item.description || item.descripcion || '',
                                    internal_id: internalId,
                                    quantity: item.unidades || 1,
                                    timestamp: Date.now() + Math.random()
                                }
                            }))

                        const listaActual = Object.assign([], this.inventory)
                        const listaNueva = listaActual.concat(itemsWithId)
                        this.$store.commit('inventario/UPDATE_LISTA_INVENTORY', listaNueva)

                        this.plantillaSeleccionada = data.data

                        this.$store.commit('mainUI/OPEN_BAR', {
                            state: true,
                            text: `Se agregaron ${itemsWithId.length} items del kit "${data.data.tipo}"`,
                            color: 'success',
                            timeout: 2000
                        })
                    }
                }
            } catch (error) {
                console.error('Error cargando plantilla:', error)
                this.$store.commit('mainUI/OPEN_BAR', {
                    state: true,
                    text: 'No se pudo cargar la plantilla de equipamiento',
                    color: 'error',
                    timeout: 3000
                })
            } finally {
                this.loadingPlantilla = false
            }
        },

  

        deleteItem(item) {
            const lista = Object.assign([], this.inventory)
            this.$store.commit('inventario/UPDATE_LISTA_INVENTORY', lista.filter((v) => v.timestamp != item.timestamp))
            //this.listaServicios = lista
        },
        upItem(newItem) {
            const position = this.inventory.findIndex((x) => x.timestamp == newItem.timestamp)
            //console.log('position ', position)
            const lista = Object.assign([], this.inventory)
            if (position >= 1) {
                const oldItem = { ...lista[position - 1], timestamp: Date.now() }
                ////console.log('lista ', lista)
                lista.splice(position, 1, oldItem)
                ////console.log('lista 1', lista)
                lista.splice(position - 1, 1, newItem)
                ////console.log('lista ', lista)
                //colors.splice(2, 0, 'purple');

                this.$store.commit('inventario/UPDATE_LISTA_INVENTORY', lista)
            }
        },
        postData() {
            this.$validator.validateAll().then(async (result) => {
                if (result) {
                    // Use selectedProduct if available, otherwise find from search results
                    const _servicio = this.selectedProduct || this.searchResults.find(x => x.id == this.servicio.id)
                    console.log('this.servicio', this.servicio, _servicio)
                    const lista = Object.assign([], this.inventory)
                    //console.log('service')
                    lista.push({
                        id: this.servicio.id,
                        quantity: parseFloat(this.servicio.quantity),
                        name: _servicio.name || _servicio.description,
                        internal_id: _servicio.internal_id,
                        timestamp: Date.now()
                    })
                    //console.log('lista', lista)
                    this.$store.commit('inventario/UPDATE_LISTA_INVENTORY', lista)
                    this.servicio = DefaultForm.formSelectServicio()
                    this.selectedProduct = null
                    this.searchResults = []
                    this.productSearch = ''
                }
            })
        }
    }
}
</script>
<style></style>
